<form role="form" [formGroup]="classForm">
  <h1 mat-dialog-title>{{data.title}}</h1>
  <div>

    <div formArrayName="Students">
      <div style="display:flex">
        <span style="font-size:16px;padding:11px;">Students</span>
        <div style="flex-grow: 5; text-align: right;padding:3px">
          <button type="button" mat-button (click)="addStudent()">Add</button>
        </div>
      </div>
      <div style="overflow-y:scroll;max-height:400px;">
        <div style="display: flex; align-items: center; justify-content:center;" *ngFor="let m of students().controls; let i=index" [formGroupName]="i">
          <mat-form-field appearance="fill" style="width: 90%;">
            <mat-label>Select Student</mat-label>
            <mat-select formControlName="Sysref">
              <mat-option *ngFor="let student of (dataStudentList$ | async)" [value]="student.sysRef">
                {{student.firstName}} {{student.lastName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      
    </div>

  </div>
  <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Close</button>
      <button mat-button [mat-dialog-close]="" cdkFocusInitial (click)="addStudents()">Save</button>
  </div>
</form>
